import fi from "./fi.json";
import sv from "./sv.json";

export default { fi, sv };
